import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { NamedColorsHEX, ScreenSizesPx } from '../util/styles';
import { productCategories } from '../util/constants';

const ScCategories = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  list-style: none;
  margin: 20px 0;
  padding: 0;
  width: 100%;

  li {
    border-radius: 4px;
    border: 1px solid ${NamedColorsHEX.KahPurple};
    height: 120px;
    margin: 10px;
    padding: 2px;
    text-align: center;
    width: 120px;

    @media screen and (min-width: ${ScreenSizesPx.medium}px) {
      height: 136px;
      width: 136px;
    }

    img {
      height: 80px;
    }

    a {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
    }

    a,
    a:visited {
      color: ${NamedColorsHEX.KahPurple};
    }
  }

  li:nth-child(odd) {
    border: 1px solid ${NamedColorsHEX.LightSeaGreen};

    a,
    a:visited {
      color: ${NamedColorsHEX.LightSeaGreen};
    }
  }
`;

export const CategoriesNavigation = () => {
  return (
    <nav className="babys-cursive">
      <ScCategories>
        {productCategories.map((category) => (
          <li key={category.id}>
            <Link to={`/presentes/c/${category.id}`}>
              <img src={category.image} alt={category.title}></img>
              <span>{category.title}</span>
            </Link>
          </li>
        ))}
      </ScCategories>
    </nav>
  );
};
